
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/venda-imatges",
      function () {
        return require("private-next-pages/corporatiu/venda-imatges/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/venda-imatges"])
      });
    }
  